import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const propTypes = {
  header: PropTypes.node,
  children: PropTypes.node,
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.node,
    header: PropTypes.node,
    content: PropTypes.node,
  })),
  initialExpanded: PropTypes.bool,
  showDivider: PropTypes.bool,
  className: PropTypes.string,
  onToggle: PropTypes.func,
};

const defaultProps = {
  header: null,
  children: null,
  items: [],
  initialExpanded: false,
  showDivider: true,
  className: '',
  onToggle: null,
};

export const Accordion = ({
  header,
  children,
  items,
  initialExpanded,
  showDivider,
  className,
  onToggle,
}) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  const handleToggle = useCallback((event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    setExpanded((prev) => {
      const next = !prev;
      if (onToggle) {
        onToggle(next);
      }
      return next;
    });
  }, [onToggle]);

  if (items && items.length > 0 && !header) {
    return (
      <div className={cx('volta-accordion-list', className)}>
        {items.map((item, idx) => (
          <Accordion
            key={idx}
            header={item.header || item.title}
            initialExpanded={initialExpanded}
            showDivider={showDivider}
            onToggle={onToggle}
          >
            {item.content}
          </Accordion>
        ))}
      </div>
    );
  }

  const textClasses = cx({
    'text-color-dark-slate': !expanded,
    'text-color-blue': expanded,
  });

  const arrowClasses = cx({
    'float-right': true,
    'iconified-font': true,
    'iconified-chevron-down': !expanded,
    'iconified-chevron-up': expanded,
    clickable: true,
  });

  const bodyClasses = cx({
    'padding-top-20': true,
    'hidden-xs hidden': !expanded,
  });

  return (
    <div className={cx('volta-accordion padding-top-20', className)}>
      <div onClick={handleToggle} className={textClasses}>
        <span className={arrowClasses} />
        {header}
      </div>
      <div className={bodyClasses}>
        {children}
      </div>
      {showDivider ? <hr className="margin-top-30" /> : null}
    </div>
  );
};

Accordion.propTypes = propTypes;
Accordion.defaultProps = defaultProps;

export default Accordion;
